import React, {useState, useEffect} from 'react'
import { Link } from 'react-router-dom';

const Footer = () => {
  const[currentYear, setCurrentYear] = useState(null);
  useEffect(() => {
    setCurrentYear(new Date().getFullYear());
  }, [])
  
  return (
    <>
      <footer className="main-footer"><div className="footer-bottom pt-50 pb-40"><div className="container"><div className="row"><div className="col-lg-12 text-center"><div className="copyright-text"><p>&copy; {currentYear} <Link to="/">Zahid</Link> All Rights Reserved.</p></div></div></div></div></div></footer>
    </>
  )
}

export default Footer